import { Avatar, AvatarImage, AvatarFallback, AvatarStroke } from "../../components/ui/avatar";
import { cn } from "../../lib/utils";

interface UserAvatarProps {
    src?: string | null;
    name?: string;
    className?: string;
    onClick?: () => void;
    /** true이면 원형(rounded-full) 아바타 사용 (1:1 채팅 등) */
    useCircle?: boolean;
    /** 'text'이면 src 없을 때 텍스트 fallback 사용 */
    fallbackType?: 'figma' | 'text';
}

// anonymous.svg 또는 빈 값이면 실제 프로필 이미지가 아님
const hasRealPhoto = (src?: string | null): boolean =>
    !!src && !src.includes('anonymous') && src.trim() !== '';

export function UserAvatar({ src, name, className, onClick, useCircle, fallbackType }: UserAvatarProps) {
    const isCircle = useCircle || className?.includes('rounded-full')
    const showImage = hasRealPhoto(src)
    
    return (
        <div className={cn("relative shrink-0", className)} onClick={onClick}>
            <Avatar className="w-full h-full" useCircle={isCircle}>
                {showImage ? <AvatarImage src={src!} className="object-cover" /> : null}
                <AvatarFallback useFigmaDefault={!isCircle && fallbackType !== 'text'}>
                    {/* 원형 모드 또는 text fallback에서는 텍스트 폴백 */}
                    {(isCircle || fallbackType === 'text') && (
                        <svg viewBox="0 0 100 100" className="w-full h-full fill-current text-muted-foreground">
                            <text
                                x="50"
                                y="50"
                                dy=".35em"
                                textAnchor="middle"
                                fontSize="55"
                                fontWeight="bold"
                                fontFamily="sans-serif"
                            >
                                {name?.charAt(0).toUpperCase() || "?"}
                            </text>
                        </svg>
                    )}
                </AvatarFallback>
            </Avatar>
            {/* squircle 모드에서만 스트로크 오버레이 표시 (실제 이미지가 있을 때만) */}
            {!isCircle && showImage && <AvatarStroke />}
        </div>
    );
}

